import React, { useState } from "react";
import { faker } from "@faker-js/faker";
import IndexServices from "../services/IndexServices";
import Cookies from "js-cookie";
import Loader from "../general_components/Loader";
import SuccessMessage from "../general_components/SuccessMessage";
import ErrorMessage from "../general_components/ErrorMessage";

export const AdminsContext = React.createContext();

export default function AdminsContextProvider({ children }) {
  const [admins, setAdmins] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [openDel, setOpenDel] = useState(false);
  const [load, setLoad] = useState(false);
  const [clickedAdminId, setClickedAdminId] = useState(null);
  const storedRole = Cookies.get("role");
  //Loading
  const [loading, setLoading] = useState(false);

  //Confirmation Open-Close
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [iconStyled, setIconStyled] = useState(false);

  //Which Item
  const [index, setIndex] = useState(-1);

  //Add Admins
  const [openAddAdmins, setOpenAddAdmins] = useState(false);
  const [name, setName] = useState(""),
    [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [logo, setLogo] = useState(""),
    [adminType, setAdminType] = useState(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  function handleDelete() {
    IndexServices.deleteAdmin(clickedAdminId, { role: storedRole })
      .then((response) => {
        if (response.data.success) {
          setAdmins(response?.data?.data);
          setOpen(false);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage(e);
      });
  }

  const handleAddData = () => {
    const data = {
      id: faker.datatype.uuid(),
      email: email,
      name: name,
      avatar: null,
      adminType: adminType,
    };
    setAdmins([...admins, data]);
    handleEmpty();
  };

  const handleEmpty = () => {
    setName("");
    setEmail("");
    setPassword("");
    setAdminType(null);
  };

  return (
    <AdminsContext.Provider
      value={{
        admins,
        setAdmins,
        openConfirmation,
        setOpenConfirmation,
        handleDelete,
        index,
        setIndex,
        loading,
        setLoading,
        openAddAdmins,
        setOpenAddAdmins,
        logo,
        setLogo,
        handleAddData,
        name,
        setName,
        email,
        setEmail,
        password,
        setPassword,
        adminType,
        setAdminType,
        iconStyled,
        setIconStyled,
        handleEmpty,
        openDel,
        setOpenDel,
        load,
        setLoad,
        clickedAdminId,
        setClickedAdminId,
        confirm,
        setConfirm,
        open,
        setOpen,
      }}
    >
      {children}
      <Loader open={open} close={setOpen} />
      <SuccessMessage open={confirm} close={setConfirm} />
      <ErrorMessage open={error} close={setError} message={errorMessage} />
    </AdminsContext.Provider>
  );
}
